// Persistence for the Smart Asset Import "learned dictionary".
//
// This is how the module gets smarter over time WITHOUT any AI: when a user confirms a
// header mapping in the review screen, we remember normalizedHeader -> fieldKey so the
// same header auto-maps on the next import. Stored in localStorage (MongoDB-migration
// ready, same pattern as assetClassificationDB.js).
//
// Note: we deliberately persist only header->field aliases (a structural choice the user
// confirmed), NOT value->master resolutions. A spelling variant being accepted once for
// one client must never silently auto-match for another — that would be exactly the kind
// of fuzzy/fallback behavior the data-reliability rules forbid.

const DB_NAME = 'smart_import_dictionary';
const DB_VERSION = '1.0';

const load = () => {
  try {
    const raw = localStorage.getItem(DB_NAME);
    if (!raw) {
      return { _version: DB_VERSION, headerAliases: {} };
    }
    const parsed = JSON.parse(raw);
    if (!parsed.headerAliases) parsed.headerAliases = {};
    return parsed;
  } catch (e) {
    console.error('Error loading smart import dictionary:', e);
    return { _version: DB_VERSION, headerAliases: {} };
  }
};

const save = (db) => {
  try {
    db._updatedAt = new Date().toISOString();
    localStorage.setItem(DB_NAME, JSON.stringify(db));
    return true;
  } catch (e) {
    console.error('Error saving smart import dictionary:', e);
    return false;
  }
};

/** Get the learned alias map: { normalizedHeader: fieldKey }. */
export const getLearnedAliases = () => load().headerAliases || {};

/** Remember that a normalized header maps to a canonical field. */
export const learnAlias = (normalizedHeader, fieldKey) => {
  if (!normalizedHeader || !fieldKey) return false;
  const db = load();
  db.headerAliases[normalizedHeader] = fieldKey;
  return save(db);
};

/** Forget a learned alias (e.g. user corrected a previous mistake). */
export const forgetAlias = (normalizedHeader) => {
  const db = load();
  if (db.headerAliases[normalizedHeader] !== undefined) {
    delete db.headerAliases[normalizedHeader];
    return save(db);
  }
  return false;
};
